export default "__VITE_PUBLIC_ASSET__ede74a4c__"